import React from "react";
import PreFooter from "../components/PreFooter";
import Flow from "../components/service/Flow";
import Hero from "../components/service/Hero";

function Services() {
  return (
    <>
      <Hero />
      <Flow />
      <PreFooter />
    </>
  );
}

export default Services;
